
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://swhwykzorcbiutczhjgn.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InN3aHd5a3pvcmNiaXV0Y3poamduIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzgyMjI2NzksImV4cCI6MjA1Mzc5ODY3OX0.UwpU4AwW_PFuck666iRg8-MSU7jTzJJ-LXZLLTobTk0";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    persistSession: true,
    storageKey: 'app-session',
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: 'pkce'
  }
});
